import { ModemCode } from '@origin-digital/sales-common';

export enum ModemType {
  EERO7 = 'EERO7',
  TPLINKVX = 'TPLINKVX',
}

export const amazonModems = [ModemType.EERO7];

export const modemDetailsConfig: Record<
  ModemType,
  {
    modemImageSrc: string;
    modemImageAlt: string;
    modemName: string;
    features: string[];
  }
> = {
  [ModemType.EERO7]: {
    modemImageSrc:
      'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/broadband/modem_eero6.png',
    modemImageAlt: 'Amazon eero 7',
    modemName: 'Amazon eero 7',
    features: [
      'True Mesh: covers up to 140m² and supports 75+ devices',
      'WiFi 7 power: faster speeds, less congestion',
      'Easy setup: app-based install in minutes',
      'Smart home ready: works with Alexa and other Amazon devices, plus eero Secure included',
      'Built-in security: eero Secure included (valued at $5/month)',
    ],
  },
  [ModemType.TPLINKVX]: {
    modemImageSrc:
      'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/broadband/modem_tp-link.png',
    modemImageAlt: 'TP Link VX230v',
    modemName: 'TP-Link VX230v',
    features: [
      'Fast and reliable: WiFi 6 speeds up to 1.8Gbps',
      'Whole-home coverage: EasyMesh support for seamless expansion',
      'All-in-one: built-in modem, router and Gigabit ports',
      'Plug-and-play: compatible with all nbn® and Opticomm types',
    ],
  },
};

export const modemPricingOptionsConfig: Record<
  ModemCode,
  { modemType: ModemType; priceDescription: string; order: number }
> = {
  [ModemCode.FREE_EERO]: {
    modemType: ModemType.EERO7,
    priceDescription: 'when you stay for 24 months',
    order: 1,
  },
  [ModemCode.EERO]: {
    modemType: ModemType.EERO7,
    priceDescription: 'upfront payment',
    order: 2,
  },
  [ModemCode.FREE_TP_LINK]: {
    modemType: ModemType.TPLINKVX,
    priceDescription: 'when you stay for 24 months',
    order: 1,
  },
  [ModemCode.TP_LINK]: {
    modemType: ModemType.TPLINKVX,
    priceDescription: 'upfront payment',
    order: 2,
  },
};
